import React from 'react';
import { roleOptions, statusOptions } from '../helpers/settingsUsersFormConfig';

export const SettingsUsersFormFields = ({
    form,
    onInputChange,
    includeStatus = false,
    onStatusChange,
    includePassword = false,
}) => {
    return (
        <div className="row g-3">
            <div className="col-md-6">
                <label className="form-label fw-semibold">Nombre</label>
                <input className="form-control" name="firstName" value={form.firstName} onChange={onInputChange} />
            </div>
            <div className="col-md-6">
                <label className="form-label fw-semibold">Apellido</label>
                <input className="form-control" name="lastName" value={form.lastName} onChange={onInputChange} />
            </div>
            <div className="col-md-8">
                <label className="form-label fw-semibold">Email</label>
                <input className="form-control" name="email" type="email" value={form.email} onChange={onInputChange} />
            </div>
            <div className="col-md-4">
                <label className="form-label fw-semibold">Rol</label>
                <select className="form-select form-select-sm" name="role" value={form.role} onChange={onInputChange}>
                    {roleOptions.map((option) => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>
            </div>

            {includeStatus && (
                <div className="col-md-6">
                    <label className="form-label fw-semibold">Estado</label>
                    <select className="form-select form-select-sm" value={form.active ? 'ACTIVE' : 'INACTIVE'} onChange={onStatusChange}>
                        {statusOptions.map((option) => (
                            <option key={option.value} value={option.value}>{option.label}</option>
                        ))}
                    </select>
                </div>
            )}

            {includePassword && (
                <div className="col-md-6">
                    <label className="form-label fw-semibold">Nueva contraseña (opcional)</label>
                    <input
                        className="form-control"
                        name="password"
                        type="password"
                        value={form.password}
                        onChange={onInputChange}
                        placeholder="Escribe solo si deseas cambiarla"
                    />
                </div>
            )}
        </div>
    );
};
